import styled from '@emotion/styled'
import { Box } from 'theme-ui'

import media from './../../../common/MediaQueries'

const PromotionListContainerStyled = styled.div`
  width: 100%;
`

const PromotionListItemStyled = styled(Box)`
  width: 100%;
  display: flex;
  height: auto;

  flex-basis: 100%;
  max-width: 100%;

  @media ${media.maxPhone} {
    &:not(:last-of-type) {
      padding: 0 0 98px 0;
    }
  }

  @media ${media.phone} {
    padding: 1.375rem;
    flex-basis: 50%;
    max-width: 50%;
  }

  @media ${media.tablet} {
    flex: 1;
    flex-basis: 33.33333333%;
    max-width: 33.33333333%;
  }
  @media ${media.desktop} {
    padding: 2.625rem;
  }
`

const PromotionListStyled = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media ${media.phone} {
    margin: 0 -1.375rem;
  }

  @media ${media.desktop} {
    margin: 0 -2.625rem;
  }
`

export { PromotionListContainerStyled, PromotionListStyled, PromotionListItemStyled }
